// import CarFlow from '../layout/products/car/CarFlow';
// import AccidentFlow from '../layout/products/accident/AccidentFlow';
import EmployeeHealthcareFlow from '../layout/products/employeeHealtcare/EmployeeHealthcareFlow';
// import HomeFlow from '../layout/products/home/HomeFlow/HomeFlow';
import CompanyCarFlow from '../layout/products/companyCar/CompanyCarFlow/CompanyCarFlow';
// import MotorcycleFlow from '../layout/products/motorcycle/MotorcycleFlow';
// import VillaHomeFlow from '../layout/products/villaHome/VillaHomeFlow';
import PageNotFound from '../layout/products/PageNotFound';
import { RedirectComponent } from '../layout/products/RedirectComponent';

export interface ProductConfig {
    component: any;
    labelText: string;
    link: string;
}

export const PRODUCTS_CONFIG: ProductConfig[] = [
    {
        component: RedirectComponent,
        labelText: 'Car',
        link: '/(car|bil|car/calculation)'
    },
    {
        component: PageNotFound,
        labelText: 'Car',
        link: '/pageNotFound'
    },
    {
        component: RedirectComponent,
        labelText: 'Home',
        link: '/home'
    },
    {
        component: RedirectComponent,
        labelText: 'Accident',
        link: '/accident'
    },
    {
        component: EmployeeHealthcareFlow,
        labelText: 'EmployeeHealthcareFlow',
        link: '/healthcare'
    },
    {
        component: CompanyCarFlow,
        labelText: 'CompanyCarFlow',
        link: '/company-car'
    },
    {
        component: RedirectComponent,
        labelText: 'MotorcycleFlow',
        link: '/motorcycle'
    },
    {
        component: RedirectComponent,
        labelText: 'VillaHomeFlow',
        link: '/villa-home'
    }
];
